
import { Component, Prop, Vue, Watch } from "nuxt-property-decorator";
import { Term } from "@/types/components";
import { BIcon, BIconXCircle, BIconPencilSquare, BIconPlusLg } from "bootstrap-vue";

@Component({ components: { BIcon, BIconXCircle, BIconPencilSquare, BIconPlusLg } })
export default class TheSelectIvg extends Vue {
  @Prop() value!: any;
  @Prop() options!: Array<Term>;
  @Prop() componentClass!: string;
  @Prop({ default: false }) isloading: boolean;

  public visibleFilter: boolean = false;
  public optionsIvg: Array<any> = [];
  public resetSelected: boolean = false;

  @Watch("options")
  onOptionsChanged(val: any) {
    this.optionsIvg = val?.map((item: any) => {
      return {
        alias: item.value,
        value: item.value + "<b>(" + item.count + ")</b>",
      };
    });
  }

  public openFilter() {
    this.visibleFilter = true;
  }

  public clearFilter() {
    this.$emit("set-value", []);
    this.visibleFilter = true;
  }

  public closeFilter() {
    this.visibleFilter = false;
  }

  public selectedIvg(arr: string[]) {
    this.$emit("set-value", arr);
    this.visibleFilter = false;
  }
}
